export default __webpack_public_path__ + "static/media/bg-about.fae525df.jpg";